import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Year } from '../../../shared-components/year/year.model';
import { Student } from '../../../shared-components/student/student.model';
import { StudentDocuments } from '../../../shared-components/student/student-documents.model';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { StudentService } from '../../../shared-components/student/student.service';
import { YearService } from '../../../shared-components/year/year.service';
import { UserService } from '../../../shared-components/user/user.service';
import { StudentAttachment } from '../../../shared-modules/student-attachment/student-attachment.model';
import { System } from '../../../shared-components/System';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { StudentDocumentsFilteredComponent } from '../student-documents-filtered.component';
import { SharedService } from '../../../shared-components/shared.service';
import { StudentDocumentsFilter } from '../student-documents-filter';
import * as moment from 'moment';
import { Student360Service } from '../../student360.service';
import { StudentDocumentAccessHistoryComponent } from '../student-document-access-history/student-document-access-history.component';
import { ActivatedRoute } from '@angular/router';
import { SecurityService } from '../../../shared-components/security/security.service';
import { UserPermission } from '../../../shared-components/user/user-permission.model';
import { GeneralConfirmationComponent } from '../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { AddEditDocumentComponent } from '../add-edit-document/add-edit-document.component';
import { take } from 'rxjs/operators';

@Component({
  selector: 'student-documents-v9',
  templateUrl: './student-documents-v9.component.html',
  styleUrls: ['./student-documents-v9.component.css']
})
export class StudentDocumentsV9Component extends StudentDocumentsFilteredComponent implements OnInit, OnDestroy {

  student360YearSubscription: Subscription;
  student360Year: Year;
  selectedStudentSubscription: Subscription;
  selectedStudent: Student;
  V9UserPermissions: UserPermission[] = [];

  // ------------Selection/Flags-----------------------------------
  V10: boolean;
  isBusy = false;
  showOnlyBehaviorLettersDocument = false;
  studentDocumentsLength = 0;
  showFormsForEntireFamily = false;
  canAddAll = false;
  canAddViewAll = false;
  canAdd = false;
  userType: number;

  // ----------Angular Material------------------------------------
  @ViewChild(MatSort) sort: MatSort;
  columnsToDisplay = ['Name', 'Notes', 'DocumentType', 'DocumentFor', 'CreatedOn', 'CreatedBy', 'RecentAccessHistory'];

  constructor(
    studentService: StudentService,
    yearService: YearService,
    private userService: UserService,
    changeDetector: ChangeDetectorRef,
    sharedService: SharedService,
    student360Service: Student360Service,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private securityService: SecurityService,
  ) {
    super(
      studentService,
      yearService,
      sharedService,
      changeDetector,
      student360Service
    );
    this.selectedStudentSubscription = studentService.selectedStudentStream$.subscribe(
      studentId => {
        // Reload student data when the selected student is changed (Student button in the header)
        this.loadStudentInfo(studentId);
      });

    this.student360YearSubscription = yearService.observableStudent360YearStream$.subscribe(
      student360Year => {
        // Reload AcademicHistory when the selected year is changed
        this.getStudentDocuments();
      });

    // Load data into a DataSource object
    // MatTableDataSource extends DataSource to allow sorting, pagination and basic filtering
    // TylerMatTableDataSource extends MatTableDataSource and allows complex filtering and detail rows
    this.angularMatData = new TylerMatTableDataSource(this.studentDocuments);

    // Copy flag from service to local variable
    // This prevents having to directly call a service from the html, keeping the view loosely coupled
    this.V10 = this.userService.currentUser.V10;

    if (this.V10) {
      this.columnsToDisplay = ['Name', 'DocumentType', 'FileType', 'V10Notes', 'CreatedOn'];
    }
    this.userType = this.userService.userType;
    if (this.userType == 1) {
      this.columnsToDisplay = ['Name', 'Notes', 'DocumentType', 'DocumentFor', 'CreatedOn', 'CreatedBy', 'RecentAccessHistory', 'Actions'];
    }
  }

  ngOnInit() {
    if (!this.V10) {
      this.activatedRoute.queryParams.subscribe(params => {
        const onlyBehaviorLettersDocument = params['onlyBehaviorLettersDocument'];
        if (onlyBehaviorLettersDocument && onlyBehaviorLettersDocument == "true") {
          this.showOnlyBehaviorLettersDocument = true;
        }
      });
    }
    const permissions = this.securityService.userPermissions;
    this.V9UserPermissions = permissions;

    const checkPermissionAll = this.V9UserPermissions.filter(permission => permission.PermissionCode == 'DSF_MADFSF')[0];
    if (checkPermissionAll != undefined && checkPermissionAll != null) {
      this.canAddAll = true;
    }
    const checkPermissionViewAll = this.V9UserPermissions.filter(permission => permission.PermissionCode == 'DSF_VADFSF')[0];
    if (checkPermissionViewAll != undefined && checkPermissionViewAll != null) {
      this.canAddViewAll = true;
    }
    const checkPermission = this.V9UserPermissions.filter(permission => permission.PermissionCode == 'DSF_MDSF')[0];
    if (checkPermission != undefined && checkPermission != null) {
      this.canAdd = true;
    }
    // Initial data load
    const initialFilter: StudentDocumentsFilter = {
      fileName: '',
      createdFrom: moment().subtract(1, 'year').toDate(),
      createdTo: undefined,
      addedBy: '',
      description: '',
      documentType: '',
      fileType: '',
      for: ''
    };
    super.setFilter(initialFilter);
    this.loadStudentInfo(this.studentService.selectedStudent.Id);
  }

  ngOnDestroy() {

  }

  // ------------ Student Documents Data ---------------------------
  loadStudentInfo(studentId: number) {
    this.selectedStudent = this.studentService.students.filter(function (student) {
      return student.Id == studentId;
    })[0];
    this.getStudentDocuments();
  }

  getStudentDocuments(showEntireFamilyDocuments: boolean = false) {
    this.isBusy = true;
    this.angularMatData.data = [];
    this.studentDocumentsLength = 0;

    setTimeout(() => {
      this.studentService.getStudentDocuments(this.selectedStudent.Id, this.yearService.student360Year.Id, showEntireFamilyDocuments).pipe(take(1)).subscribe(data => {
        this.studentDocuments = data;

        if (!this.V10 && this.showOnlyBehaviorLettersDocument == true) {
          this.studentDocuments = this.studentDocuments.filter(x => x.Notes == "Behavior Letter");
        }
        this.studentDocumentsLength = this.studentDocuments.length;
        this.loadStudentDocuments();
      });
    }, 0);
  }

  loadStudentDocuments() {
    // load data into Angular Material table
    this.angularMatData.data = this.studentDocuments;
    this.applyFilter();
    setTimeout(() => {
      this.angularMatData.sort = this.sort;
    }, 0);

    this.isBusy = false;
  }

  viewAttachment(row: StudentDocuments) {
    const studentAttachment: StudentAttachment = {
      DocumentId: this.V10 == false ? row.DocumentId : 0,
      DocumentName: row.Name,
      DocumentBase64: row.FileBase64,
      DocumentMimeType: row.FileMimeType,
      DocumentModuleName: 'Documents',
      ReportParameters: [],
      ReportType: 0
    };
    window.localStorage.setItem('studentAttachment', JSON.stringify(studentAttachment));
    const win = window.open(System.baseUrl + 'studentattachment', '_blank');
    win.focus();
    let timer = setInterval(() => {
      if (!timer) {
        clearInterval(timer);
      }
      if (win.closed) {
        this.ngOnInit();
        clearInterval(timer);
        win.focus();
      }
    }, 1000);
  }

  // ------------Aria/Accessibility---------------------------
  getAriaRow(row: StudentDocuments): string {
    // Returns string for a given row's data
    // reads each column header name and then the cell data for that column
    let colList: string[] = [''];
    let dataList: string[] = [''];

    if (this.V10 == false) {
      colList = ['File Name', 'Description', 'Category', 'For', 'Added', 'Added by'];
      dataList = [row.Name, row.Notes, row.DocumentType, row.DocumentFor, row.CreatedOn.toString(), row.CreatedBy];
    } else {
      colList = ['File Name', 'Document Type', 'File Type', 'Description/Comments', 'Created'];
      dataList = [row.Name, row.DocumentType, row.FileType, row.Notes, row.CreatedOn.toString()];
    }

    return AriaDirective.concatAriaStrings(colList, dataList);
  }
  studentAccessHistoryClick(row: StudentDocuments) {
    const dialogRef = this.dialog.open(StudentDocumentAccessHistoryComponent, {
      disableClose: true,
      data: { AccessHistory: row.AccessHistory }
    });
  }

  editClick(doc: StudentDocuments) {
    if (doc.StudentId > 0) {
      this.studentService.getStudent(doc.StudentId).subscribe((studentData) => {
        doc.StudentName = studentData.LastName + ', ' + studentData.FirstName + ' ' + studentData.MiddleName;
        doc.StudentId = studentData.Id;
        doc.FamilyId = studentData.FamilyId;
        const dialogBox = this.dialog.open(AddEditDocumentComponent, {
          disableClose: true,
          minWidth: '500px',
          data: {
            attachments: doc
          }
        });
        dialogBox.afterClosed().subscribe((action: string) => {
          if (action == 'Save') {
            const newAttachment = dialogBox.componentInstance.attachment;
            doc.DocumentTypeId = newAttachment.DocumentTypeId;
            doc.FileName = newAttachment.OriginalFileName;
            doc.FileType = newAttachment.FileType;
            doc.Notes = newAttachment.Description;
            doc.FileBase64 = newAttachment.MyFileBase64String;
            if (doc.StudentId == null) {
              doc.StudentId = this.selectedStudent.Id;
            }
            doc.DocumentFor = newAttachment.DocumentType != 'Household' ? doc.StudentName : 'Family';
            if (this.selectedStudent.Id > 0) {
              this.studentService.saveAttachment(doc, doc.DocumentFor).subscribe(result => {
                this.getStudentDocuments();
              });
            }
          }
        });
      });
    }
    else {
      doc.StudentName = this.selectedStudent.LastName + ', ' + this.selectedStudent.FirstName + ' ' + this.selectedStudent.MiddleName;
      doc.StudentId = this.selectedStudent.Id;
      doc.FamilyId = this.selectedStudent.FamilyId;
      const dialogBox = this.dialog.open(AddEditDocumentComponent, {
        disableClose: true,
        minWidth: '500px',
        data: {
          attachments: doc
        }
      });
      dialogBox.afterClosed().subscribe((action: string) => {
        if (action == 'Save') {
          const newAttachment = dialogBox.componentInstance.attachment;
          doc.DocumentTypeId = newAttachment.DocumentTypeId;
          doc.FileName = newAttachment.OriginalFileName;
          doc.FileType = newAttachment.FileType;
          doc.FileBase64 = newAttachment.MyFileBase64String;
          doc.Notes = newAttachment.Description;
          if (doc.StudentId == null) {
            doc.StudentId = this.selectedStudent.Id;
          }
          doc.DocumentFor = newAttachment.DocumentType != 'Household' ? doc.StudentName : 'Family';
          if (this.selectedStudent.Id > 0) {
            this.studentService.saveAttachment(doc, doc.DocumentFor).subscribe(result => {
              this.getStudentDocuments();
            });
          }
        }
      });
    }
  }
  addAttachmentClick() {
    const newDocument: StudentDocuments = new StudentDocuments();
    newDocument.DocumentId = -1;
    newDocument.StudentName = this.selectedStudent.LastName + ', ' + this.selectedStudent.FirstName + ' ' + this.selectedStudent.MiddleName;
    newDocument.StudentId = this.selectedStudent.Id;
    newDocument.FamilyId = this.selectedStudent.FamilyId;
    newDocument.DocumentType = newDocument.StudentName;
    const dialogBox = this.dialog.open(AddEditDocumentComponent, {
      disableClose: true,
      minWidth: '500px',
      data: {
        attachments: newDocument
      }
    });
    dialogBox.afterClosed().subscribe((action: string) => {
      if (action == 'Save') {
        const newAttachment = dialogBox.componentInstance.attachment;
        newDocument.DocumentTypeId = newAttachment.DocumentTypeId;
        newDocument.FileName = newAttachment.OriginalFileName;
        newDocument.FileType = newAttachment.FileType;
        newDocument.FileBase64 = newAttachment.MyFileBase64String;
        newDocument.Notes = newAttachment.Description;
        newDocument.DocumentFor = newAttachment.DocumentType != 'Household' ? newDocument.StudentName : 'Family';
        if (this.selectedStudent.Id > 0) {
          this.studentService.saveAttachment(newDocument, newDocument.DocumentFor).subscribe(result => {
            this.getStudentDocuments(this.showFormsForEntireFamily);
          });
        }
      }
    });
  }
  deleteDocumentClick(doc: StudentDocuments) {
    // PRE: a selected Document delete
    // POST: opens the dialog for deleting a document. If the dialog returns true, performs the deletion
    const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
      disableClose: true,
    });
    deleteConfirmDialog.componentInstance.headerLabel = ' Delete Document';
    deleteConfirmDialog.componentInstance.confirmMessage = ' Are you sure you want to delete? ';
    deleteConfirmDialog.componentInstance.okButtonLabel = 'Delete';
    deleteConfirmDialog.componentInstance.confirmEvent.subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.studentService.deleteStudentDocuments(0, doc.DocumentId, 0).subscribe(
          result => {
            this.ngOnInit();
          }
        );
      }
    });
  }
  showFormsForEntireFamilyChange(showFormsForEntireFamily: boolean) {
    this.showFormsForEntireFamily = showFormsForEntireFamily;
    this.getStudentDocuments(showFormsForEntireFamily);
  }

  editStudentMode() {
    return this.sharedService.editRegistrationStudentMode;
  }
  getPermisionCategory(permisionCategory: string) {
    const checkPermission = this.V9UserPermissions.filter(permission => permission.PermissionCode == 'DSF_MDSF' && permission.PermissionCategory == permisionCategory)[0];
    if (checkPermission != undefined && checkPermission != null) {
      return true;
    }
    return false;
  }
}
